import { render, staticRenderFns } from "./ArticulosPorRubro.vue?vue&type=template&id=227f56ac&scoped=true"
import script from "./ArticulosPorRubro.vue?vue&type=script&lang=js"
export * from "./ArticulosPorRubro.vue?vue&type=script&lang=js"
import style0 from "./ArticulosPorRubro.vue?vue&type=style&index=0&id=227f56ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227f56ac",
  null
  
)

export default component.exports